const $ = jQuery

export default function Faq() {
  const FAQS = document.querySelectorAll('.mtt-faq')
  if(FAQS.length > 0) {
    for (let i = 0; i < FAQS.length; i++) {
      const faqClass = new FaqClass(FAQS[i])
      faqClass.init()
    }
  }
}

class FaqClass {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-faq__category')
    this.CATEGORY_ID = null
    this.FAQS = this.WRAPPER.querySelectorAll('.mtt-faq__single')
    this.COLUMNS = this.WRAPPER.querySelectorAll('.mtt-faq__column')
  }

  init () {
    this.toggleElements()
    for (let i = 0; i < this.CATEGORIES.length; i++) {
      this.CATEGORIES[i].addEventListener('click', () => {
        $(this.CATEGORIES).removeClass('mtt-faq__category--active')
        $(this.CATEGORIES[i]).addClass('mtt-faq__category--active')
        this.CATEGORY_ID = this.CATEGORIES[i].getAttribute('data-category-id')
        this.loadFaq()
      })
    }
  }

  loadFaq() {
    for (let i = 0; i < this.COLUMNS.length; i++) {
      const COLUMN = this.COLUMNS[i]
      COLUMN.innerHTML = ''
    }

    const faq_array = []
    for (let i = 0; i < this.FAQS.length; i++) {
      const FAQ = this.FAQS[i]

      if(this.CATEGORY_ID === 'all') {
        faq_array.push(FAQ)
      } else if(FAQ.dataset.faqCategoryId === this.CATEGORY_ID) {
        faq_array.push(FAQ)
      }
    }

    const middleIndex = Math.ceil(faq_array.length / 2);
    const firstColumn = faq_array.splice(0, middleIndex);
    const secondColumn = faq_array.splice(-middleIndex);

    for (let i = 0; i < firstColumn.length; i++) {
      this.COLUMNS[0].appendChild(firstColumn[i])
    }

    for (let i = 0; i < secondColumn.length; i++) {
      this.COLUMNS[1].appendChild(secondColumn[i])
    }
  }

  toggleElements() {
    const clickElements = document.querySelectorAll('.mtt-faq__single-header')

    if(clickElements.length > 0) {
      for (let i = 0; i < clickElements.length; i++) {
        const clickElement = clickElements[i]
        const slideElement = clickElement.nextElementSibling
        const fadeElement = clickElement.querySelector('.mtt-faq__single-title')

        clickElement.addEventListener('click',  () => {
          $(slideElement).slideToggle('slow')
          $(clickElement).addClass('mtt-faq__single-title--isClicked')
          $(fadeElement).toggleClass('mtt-faq__single-title-hidden')

          setTimeout( () => {
            $(clickElement).removeClass('mtt-faq__single-title--isClicked')
          }, 400)
        })
      }
    }
  }
}